import { Link } from "react-router-dom";
import { useState } from "react";
import { Mail, MessageCircle, MessageSquare, Phone, X } from "lucide-react";
import { Reveal } from "@/components/Reveal";

export const MobileQuickContact = () => {
  const [open, setOpen] = useState(false);
  return (
    <div className="fixed bottom-5 right-5 z-40 md:hidden flex flex-col items-end gap-3">
      {open && (
        <div className="flex flex-col gap-2 items-end" data-testid="quick-contact-menu">
          <a
            href="tel:+447590469090"
            data-testid="quick-call-link"
            className="flex items-center gap-2.5 bg-gold text-navy font-mono text-[10px] tracking-[0.2em] uppercase px-4 py-3 shadow-2xl"
          >
            <Phone size={13} strokeWidth={1.75} /> Call Us · 07590 469090
          </a>
          <a
            href="mailto:navazhjalaludeen@nhs.net"
            data-testid="quick-email-link"
            className="flex items-center gap-2.5 bg-navy text-ivory border border-gold/40 font-mono text-[10px] tracking-[0.2em] uppercase px-4 py-3 shadow-2xl"
          >
            <Mail size={13} strokeWidth={1.75} className="text-gold" /> Email Us
          </a>
          <Link
            to="/contact"
            data-testid="quick-contact-link"
            className="flex items-center gap-2.5 bg-navy text-ivory border border-gold/40 font-mono text-[10px] tracking-[0.2em] uppercase px-4 py-3 shadow-2xl"
          >
            <MessageSquare size={13} strokeWidth={1.75} className="text-gold" /> Enquiry Form
          </Link>
        </div>
      )}
      <button
        type="button"
        onClick={() => setOpen(!open)}
        data-testid="mobile-quick-contact-button"
        aria-label={open ? "Close quick contact" : "Quick contact"}
        className="w-12 h-12 rounded-full bg-gold text-navy flex items-center justify-center shadow-2xl hover:bg-champagne transition-colors"
      >
        {open ? <X size={18} strokeWidth={1.75} /> : <MessageCircle size={18} strokeWidth={1.75} />}
      </button>
    </div>
  );
};
import { Crest } from "@/components/Crest";

export const CtaFooter = () => (
  <>
    <section className="bg-gold py-24 lg:py-28 relative overflow-hidden" data-testid="cta-section">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 grid lg:grid-cols-12 gap-12 lg:gap-16 items-center relative z-10">
        <Reveal className="lg:col-span-4">
          <div className="relative max-w-xs mx-auto lg:mx-0">
            <div className="absolute -top-4 -left-4 w-full h-full border border-navy/40" />
            <img
              src="/echo-machine.jpeg"
              alt="Cardiac ultrasound machine displaying an echocardiogram"
              className="relative w-full h-72 lg:h-80 object-cover shadow-2xl"
              data-testid="cta-echo-machine-image"
            />
          </div>
        </Reveal>
        <Reveal className="lg:col-span-8 text-center lg:text-left" delay={0.15}>
          <p className="font-mono text-[11px] tracking-[0.35em] uppercase text-navy/60 mb-4">
            Work With CVI
          </p>
          <h2 className="font-serif text-3xl sm:text-4xl lg:text-5xl font-semibold text-navy leading-tight">
            Discuss a diagnostic service.
          </h2>
          <p className="mt-6 text-base text-navy/70 max-w-xl mx-auto lg:mx-0 leading-relaxed">
            Private practice, PCN or research team — send us a message and our clinical
            team will respond within one working day.
          </p>
          <div className="mt-10 flex flex-wrap justify-center lg:justify-start gap-4">
            <Link
              to="/contact"
              data-testid="cta-request-access-button"
              className="bg-navy text-ivory font-mono text-xs tracking-[0.2em] uppercase px-10 py-4 hover:bg-obsidian transition-colors"
            >
              Contact Us
            </Link>
            <Link
              to="/login"
              data-testid="cta-login-button"
              className="border border-navy/40 text-navy font-mono text-xs tracking-[0.2em] uppercase px-10 py-4 hover:bg-navy hover:text-ivory transition-colors"
            >
              Specialist Login
            </Link>
          </div>
        </Reveal>
      </div>
    </section>

    <footer className="bg-navy border-t border-ivory/10 py-12" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 flex flex-col md:flex-row items-center justify-between gap-8">
        <div className="flex items-center">
          <Crest light className="h-10" />
        </div>
        <div className="flex flex-col items-center gap-2">
          <p className="font-mono text-[10px] tracking-[0.25em] uppercase text-ivory/40 text-center">
            Specialist-to-Specialist Portal · Est. 2014
          </p>
          <a
            href="mailto:navazhjalaludeen@nhs.net"
            data-testid="footer-email-link"
            className="font-mono text-[10px] tracking-[0.25em] uppercase text-gold/70 hover:text-gold transition-colors"
          >
            Email Us · navazhjalaludeen@nhs.net
          </a>
        </div>
        <div className="flex items-center gap-6">
          <Link to="/privacy" data-testid="footer-privacy-link" className="font-mono text-[10px] tracking-[0.25em] uppercase text-ivory/40 hover:text-gold transition-colors">
            Privacy Notice
          </Link>
          <Link to="/cookies" data-testid="footer-cookies-link" className="font-mono text-[10px] tracking-[0.25em] uppercase text-ivory/40 hover:text-gold transition-colors">
            Cookie Policy
          </Link>
          <p className="font-mono text-[10px] tracking-[0.25em] uppercase text-ivory/40">
            © {new Date().getFullYear()} Cardio-Vascular Imaging (UK) Ltd · Company No. 8915015
          </p>
        </div>
      </div>
    </footer>

    <MobileQuickContact />
  </>
);
